module.exports = __webpack_public_path__ + "static/shelter-e7cafd850d146e62802d40ac059320b6.jpg";